import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import styled from 'styled-components';
import { getBackgroundColor, themeGet } from '@magalu/stereo-ui-styles';
import Flex from '../Flex';
export const Container = styled(Flex).attrs(_ref => {
  let {
    color,
    disabled
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["color", "disabled"]);

  return Object.assign({
    alignItems: 'center',
    color: disabled ? 'text.gray' : color
  }, props);
})``;
export const Input = styled.input.attrs(() => ({
  type: 'checkbox'
}))`
  appearance: none;
  background: transparent;
  width: 20px;
  height: 20px;
  outline: none;
  cursor: pointer;

  &:not(:checked) {
    border-radius: ${themeGet('radii.medium')};
    border: ${themeGet('borders.1')};
  }

  &:checked {
    &:after {
      content: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGlkPSJzdmdJZCIgZmlsbD0iI2ZmZiIgdmlld0JveD0iMCAwIDI0IDI0IiBjbGFzcz0ic2MtYlpReW5NIGpjVFFtYyI+PHBhdGggZD0iTTkgMTYuMkw0LjggMTJsLTEuNCAxLjRMOSAxOSAyMSA3bC0xLjQtMS40TDkgMTYuMnoiLz48L3N2Zz4=');
      position: absolute;
      width: 20px;
      height: 20px;
      background: ${getBackgroundColor('primary')};
      border-radius: ${themeGet('radii.medium')};
      box-sizing: border-box;
    }

    &:disabled {
      &:after {
        background: ${getBackgroundColor('dark')};
      }
    }
  }
`;